export default [
	"<b>Marketing Strategy</b> <br/> Strategize campaigns as per category, optimise for RTO, refresh creatives, and rebalance daily campaign budgets.",
	"<b>Pricing Strategy</b> <br/> Set optimal prices through competitor benchmarking, unit economic analysis and product wise marketing feedback.",
	"<b>RTO Management</b> <br/> User segmentation basis intent, allocate best-fit couriers, and increase NDR conversions.",
	"<b>Leveraging Profit-Driven Features</b> <br/> Dynamic courier allocations, bonus order conversions, partial COD, RTO-adjusted marketing, and more.",
	"<b>Leveraging Data-Powered Insights</b> <br/> 50+ analytics dashboards monitoring campaign PnL, RTOs, and product performance",

]
